import { render } from "./cabinet.vue?vue&type=template&id=653d74d9&scoped=true&ts=true"
import script from "./cabinet.vue?vue&type=script&lang=ts"
export * from "./cabinet.vue?vue&type=script&lang=ts"

import "./cabinet.vue?vue&type=style&index=0&id=653d74d9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653d74d9"]])

export default __exports__